export default {
  OPERACION_PREGUNTA: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
